export default class InvitationsGridToolbarModel {

    public keyword: string = "";

    public invitationSent: boolean = true;

    public linkOpened: boolean = true;

    public registered: boolean = true;
}